import React from 'react'
import Fab from '@material-ui/core/Fab'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCommentDots } from '@fortawesome/free-solid-svg-icons'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { useTheme } from '@material-ui/core'

export default function NewMessageButton({ onClick }) {
    const theme = useTheme()
    const [mousedOver, setMouseOver] = React.useState(false)

    const handleMouseOver = () => setMouseOver(() => true)
    const handleMouseOut = () => setMouseOver(() => false)

    return (
        <Fab
            size="small"
            color="secondary"
            onClick={onClick}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            aria-label="scroll-to-bottom"
        >
            <FontAwesomeIcon icon={mousedOver ? faCommentDots : faArrowDown} color={theme.colors.white} />
        </Fab>
    )
}
